import { ICongressionalRecordLinks } from './index.js'

export interface ICongressionalRecordIssue {
  Congress: string
  Id: number
  Issue: string
  Links: ICongressionalRecordLinks
  PublishDate: string
  Session: string
  Volume: string
}
